<script setup>
import {reactive} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";
import JsonCSV from 'vue-json-csv';

const data = reactive({
  invoicenum: null,
  claimnum: null,
  adjname: null,
  items: [],
  headers: [
    { title: 'Invoice Number', key: 'invoice_num' },
    { title: 'Claim Number', key: 'claimnumber' },
    { title: 'Adjuster', key: 'name' },
    { title: 'Type', key: 'type' },
    { title: 'Date', key: 'date' },
    { title: 'Amount', key: 'amount' },
    { title: 'Void Date', key: 'void_date' },
    { title: 'Created Date', key: 'created_date' },
    { title: 'Collection Notes', key: 'collection_notes' },
  ],
  labels: {
    invoice_num: "Invoice Number",
    claimnumber: "Claim Number",
    name: "Adjuster",
    type: "Type",
    date: "Date",
    amount: "Amount",
    void_date: "Void Date",
    created_date: "Created Date",
    collection_notes: "Collection Notes"
  },
  loading: false
})

const search = () => {
  if(
      (data.invoicenum === null || data.invoicenum === '')
      && (data.claimnum === null || data.claimnum === '')
      && (data.adjname === null || data.adjname === '')
  )
  {
    ToastUtil.infoMsg('Please enter an Invoice Number, Claim Number, or Adjuster Name to search for.');
  }
  else{
    data.loading = true;
    ApiWrapper.post('invoices', 'search-invoices', {
      invoicenum: data.invoicenum,
      claimnum: data.claimnum,
      adjname: data.adjname,
    }).then((response) => {
      if(response){
        if(response.invoices){
          if(response.invoices.length === 0){
            ToastUtil.infoMsg('No Invoice matched this search');
          }
          else{
            data.items = response.invoices;
          }
        }
      }
      data.loading = false;
    }).catch((error) => {
      if(error.response.status === 404 ){
        console.log(error);
        ToastUtil.warningMsg(error.response.data.message);
      }
      else {
        ToastUtil.error(error);
      }
      data.loading = false;
    })
  }
}

const getCsvData = () => {
  return data.items.map(item => ({
    invoice_num: item.invoice_num === null ? '' : "'"+item.invoice_num+"'",
    claimnumber: item.claimnumber === null ? '' : "'"+item.claimnumber+"'",
    name: item.name === null ? '' : String(item.name),
    type: item.type === null ? '' : String(item.type),
    date: item.date === null ? '' : String(item.date),
    amount: item.amount === null ? '' : String(item.amount),
    void_date: item.void_date === null ? '' : String(item.void_date),
    created_date: item.created_date === null ? '' : String(item.created_date),
    collection_notes: item.collection_notes === null ? '' : String(item.collection_notes)
  }));
}

const getHeaderFields = () => {
  let headerArr = []
  for(let x in data.headers){
    headerArr.push(data.headers[x].key)
  }
  return headerArr
}

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2 mb-5 pb-5">
      <v-toolbar>
        <v-toolbar-title>Search Invoices</v-toolbar-title>
        <JsonCSV
            :data="getCsvData()"
            :fields="getHeaderFields()"
            name="Search_Invoices.csv"
            :labels="data.labels"
            :separator-excel="true"
            class="mr-5"
        >
          <v-btn size="small" variant="elevated" color="primary" :disabled="data.items.length === 0">
            <v-icon> mdi-file-download </v-icon>
          </v-btn>
        </JsonCSV>
      </v-toolbar>

      <v-row>
        <v-col cols="4" class="ml-5">
          <v-text-field label="Invoice Number" v-model="data.invoicenum"></v-text-field>
          <v-text-field label="Claim Number" v-model="data.claimnum"></v-text-field>
          <v-text-field label="Adjuster Name" v-model="data.adjname"></v-text-field>
          <v-btn block color="primary" @click="search"><v-icon icon="mdi-magnify"></v-icon> Search</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">

          <v-data-table
              class="elevation-3"
              :items="data.items"
              :headers="data.headers"
              :loading="data.loading"
              loading-text="Loading... Please wait"
              :items-per-page-options="[5, 10, 15, 30, 50, 100, 500, 1000, 2000]"
          >
            <template v-slot:[`item.claimnumber`]="{ item }">
              <RouterLink :to="`/claim/${item.uuid}`">
                {{ item.claimnumber }}
              </RouterLink>
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <RouterLink :to="`/userprofile/${item.id}`">
                {{ item.name }}
              </RouterLink>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<style scoped>

</style>